import router from '@/router/index'
import VueRouter from "vue-router";

const state = {
    permissionArr: []
}
const mutations = {
    delete: (state: any, view: any)=> {
        state.permissionArr = []
    },
    set: (state: any, view: any)=> {
        state.permissionArr = view
    }
}

export default {
    namespaced: true,  // 这个是命名空间，用来区分不同的模块，我是根据文件的名字来区分
    state,
    mutations,
};
